import React from "react";

const SortDropdown = ({
  label = "Sort by",
  value,
  onChange,
  options,
  className = "",
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {label ? (
        <label className="text-sm font-semibold text-gray-700">{label}</label>
      ) : null}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="px-4 py-2 rounded border border-gray-300 bg-white text-gray-700 font-medium focus:outline-none focus:border-blue-500 transition-colors"
      >
        {options?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SortDropdown;
